import React from 'react';
import classNames from 'classnames';
import { TbAlertTriangleFilled } from 'react-icons/tb';
import Textarea from 'react-textarea-autosize';
import { useField } from 'formik';

interface TextareaProps {
  id: string;
  name: string;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  handleRightIconClick?(): void;
  RightIcon?: React.FC;
  error?: string;
  className?: string;
}

const TextareaAutosize: React.FC<TextareaProps> = ({
  id,
  name,
  label,
  disabled,
  placeholder,
  RightIcon,
  className,
  handleRightIconClick,
  error
}) => {
  const [field] = useField(name);
  return (
    <div className="w-full mb-6">
      <div className="flex justify-between">
        {label && <div className="text-sm font-normal">{label}</div>}
        {RightIcon && (
          <div>
            <div
              className="text-primary-400 cursor-pointer"
              data-tip="Add Link"
              onClick={() => {
                handleRightIconClick();
              }}
            >
              <RightIcon />
            </div>
          </div>
        )}
      </div>

      <div className="w-full relative">
        <Textarea
          id={id}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...field}
          disabled={disabled}
          className={classNames(
            className ||
              'mt-1 w-full border rounded-md px-4 py-3 appearance-none min-h-[78px]',
            error ? 'border-red-800' : 'border-gray-200'
          )}
          placeholder={placeholder}
        />
      </div>

      {error && (
        <div className="mt-2 text-red-800 flex items-center gap-1 font-normal">
          <TbAlertTriangleFilled size={16} /> {error}
        </div>
      )}
    </div>
  );
};

export default TextareaAutosize;
